export const RDX_NAV_NAVIGATE = 'rdx/nav/navigate';
export const RDX_NAV_NAVIGATE_DONE = 'rdx/nav/navigate/done';

export const navigate = (target, params) => {
	return {
		'type': RDX_NAV_NAVIGATE,
		'target': target,
		'params': params
	};
};
export const navigateDone = () => {
	return {
		'type': RDX_NAV_NAVIGATE_DONE
	};
};